
import { Fragment, useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PropTypes from "prop-types";
import { useAppDispatch, useAppSelector } from "../../../app/hooks"
import { useForm, SubmitHandler } from "react-hook-form";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import { authActions, signupLoginStatus, verifyOtpStatus, socialSignupLoginStatus, resetPasswordStatus } from "../../../reducers/authSlice";
import { useNavigate, NavLink, useSearchParams, useParams } from "react-router-dom";
import VerifyPage from './verify';
// import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import { useGoogleLogin } from '@react-oauth/google';
import axios from "axios";
import { decodeJwt } from "../../../utils/common";
import NotFound from "./notFound";
import { useTranslation } from "react-i18next";
import { useTranslationContext } from "../../../context/locale.context";
import i18n from "../../../i18n";

const ForgotPassword = () => {
  const params = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const {locale,setLocale}=useTranslationContext();
  const target = searchParams.get("target");
  const email = searchParams.get("email");
  const {t}=useTranslation("")


  const [showPhoneForm, setShowPhoneForm] = useState(false);

  const resetPassStatus:string = useAppSelector(resetPasswordStatus);


  type CredentialInput = {
    password: any,
    passwor2:string
  }

  useEffect(() => {
    // if target is passed then 
    if (target) {
      try {
        decodeJwt(target);
      } catch (err) {
        console.error(err);
        navigate("/LinkExpired");
      }
    }

    dispatch(authActions.reset());
  }, [])


 useEffect(()=>{
    if(resetPassStatus==="success"){
        reset();
        setTimeout(()=>{
            navigate("/")
        },1500);
    }
 },[resetPassStatus])


  const { register, handleSubmit, formState: { errors }, getValues, trigger, reset } = useForm<CredentialInput>()

  const onSubmit: SubmitHandler<CredentialInput> = data => {
    let reqObj={
        email,
        id: params.id,
        newPassword: data.password?.trim()
    }
    dispatch(authActions.resetPassword(reqObj));
  }

  const updateLocale = (locale: string) => {
    setLocale(locale);
    i18n.changeLanguage(locale);
    document.cookie = `INTEGOLF_COURSES_PORTAL_LOCALE=${locale};`
  }

  if(!email) return <NotFound/>

  return (
    <section className="authWrapper">
        <div className="select-language-dropdown">
            <select
              id="languages"
              value={locale ? locale: "en"}
              className="form-select bg-transparent text-dark fw-medium border-1 p-2"
              onChange={(e) => updateLocale(e.target.value)}
            >
              <option value="en">EN</option>
              <option value="fr">FR</option>
            </select>
          </div>
      <div className="authMain flex-fill d-flex align-items-center">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-9">
              {<div className="authWrap">
                <div className="text-center mb-4">
                  <h1>
                  {t("AuthPages.ChangePassword")}
                  </h1>
                  {/* <h6 className="color-gray">Log in or sign up</h6> */}
                </div>
                <div className="d-flex justify-content-center py-5">
                  <div className="formWrap" style={{width:"350px"}}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      {!showPhoneForm && <FormTypeEmail email={email} register={register} getValues={getValues} errors={errors} trigger={trigger}/>}
                      {/* <p>
                        I agree with{" "}
                        <a href="https://www.integolf.com/privacy" target="_blank">Privacy Policy</a>
                         <br /> We'll call
                        or text you to confirm your number.
                      </p> */}
                      <div className="mb-4 pt-2">
                        <button
                          type="submit"
                          className="button button-primary button-block button-rounded button-large fw700 fontsize-16"
                        >
                          {t("AuthPages.Submit")}
                        </button>
                      </div>
                    </form>
                  </div>
                  
                </div>
              </div>}

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const FormTypeEmail = ({ register, errors, getValues, email }: any) => {
const {t}=useTranslation("")
  return (
  <Fragment>
    <div className="mb-4 pb-4">
    <div className="form-floating mb-4">
        <input
          type="text"
          className="form-control"
          id="email"
          placeholder={t("AuthPages.forgetPasswordForm.Email")}
          value={email}
          disabled={true}
        />
        <label htmlFor="password">{t("AuthPages.forgetPasswordForm.Email")}</label>
        
      </div>
        <div className="form-floating mb-4">
        <input
          type="password"
          className="form-control"
          id="password"
          placeholder={t("AuthPages.forgetPasswordForm.placeholder")}
          {...register("password", { required: true, validate: (value:any) => {
            const trimmedValue = value.trim();
            if(trimmedValue.length < 8){
              return t("AuthPages.forgetPasswordForm.minNumberPasswordError");
            }else if(getValues("password2") && getValues("password2") !== value){
                return t("AuthPages.forgetPasswordForm.notMatchPasswordError")
            }
            return true;
          } })}
        />
        {errors.password?.type == "required" && <span className="isInvalidMessage text-danger">{t("AuthPages.forgetPasswordForm.requiredPasswordError")}</span>}
        {errors.password?.type == "validate" && <span className="isInvalidMessage text-danger">{errors.password.message}</span>}
        <label htmlFor="password">{t("AuthPages.forgetPasswordForm.NewPassword")}</label>
        
      </div>
      <div className="form-floating">
        <input
          type="text"
          className="form-control"
          id="password2"
          placeholder={t("AuthPages.forgetPasswordForm.ConfirmPassword")}
          {...register("password2", { required: true, validate: (value:any) => {
            const trimmedValue = value.trim();
            if(trimmedValue.length < 8){
                return t("AuthPages.forgetPasswordForm.minNumberPasswordError");
            }else if(getValues("password") && getValues("password") !== value){
                return t("AuthPages.forgetPasswordForm.notMatchPasswordError")
            }
          } })}
        />
        {errors.password2?.type == "required" && <span className="isInvalidMessage text-danger">{t("AuthPages.forgetPasswordForm.requiredPasswordError")}</span>}
        {errors.password2?.type == "validate" && <span className="isInvalidMessage text-danger">{errors.password2.message}</span>}
        <label htmlFor="password2">{t("AuthPages.forgetPasswordForm.ConfirmPassword")}</label>
      </div>
      
    </div>
  </Fragment>
)
};

export default ForgotPassword;
